// homeData.js

export const capabilities = [
  { 
    name: "Technical Expertise", 
    description: "Programming languages, ML frameworks, MLOps, data engineering",
    percentage: "35%"
  },
  { 
    name: "Analytical & Problem Solving", 
    description: "Analyze problems, model data, interpret results effectively",
    percentage: "20%"
  },
  { 
    name: "Domain & Business", 
    description: "Domain-specific use cases and contextualize AI solutions",
    percentage: "15%"
  },
  { 
    name: "Project Delivery", 
    description: "Agile delivery, code quality, model deployment, production readiness",
    percentage: "15%"
  },
  { 
    name: "Innovation & Research", 
    description: "Contribution to new ideas, IPs, PoCs, continuous learning",
    percentage: "10%"
  },
  { 
    name: "Collaboration", 
    description: "Articulate findings, collaborate with teams, present insights",
    percentage: "5%"
  }
];

export const roles = [
  { 
    title: "Data Analyst", 
    description: "SQL, PowerBI, basic ML, storytelling",
    experience: "0-3 yrs", 
    expectedCI: "2.0-2.8"
  },
  { 
    title: "Data Scientist", 
    description: "ML algorithms, Python, model deployment",
    experience: "3-6 yrs", 
    expectedCI: "2.8-3.5"
  },
  { 
    title: "Senior Data Scientist", 
    description: "Advanced ML/DL, MLOps, solution design",
    experience: "6-9 yrs", 
    expectedCI: "3.5-4.0"
  },
  { 
    title: "AI Engineer", 
    description: "MLOps, model serving, LLM integration",
    experience: "4-8 yrs", 
    expectedCI: "3.2-3.8"
  },
  { 
    title: "Lead Data Scientist", 
    description: "Solution leadership, model optimization",
    experience: "9-12 yrs", 
    expectedCI: "4.0-4.5"
  },
  { 
    title: "Practice Lead", 
    description: "Strategic vision, architecture, mentoring",
    experience: "12+ yrs", 
    expectedCI: "4.3+"
  }
];

export const rubric = [
  { 
    level: 1, 
    name: "Beginner", 
    description: "Basic understanding, needs close supervision",
    color: "#ef4444"
  },
  { 
    level: 2, 
    name: "Developing", 
    description: "Limited experience, can execute guided tasks",
    color: "#f97316"
  },
  { 
    level: 3, 
    name: "Proficient", 
    description: "Independently executes standard tasks",
    color: "#eab308"
  },
  { 
    level: 4, 
    name: "Advanced", 
    description: "Solves complex problems, mentors others",
    color: "#3b82f6"
  },
  { 
    level: 5, 
    name: "Expert", 
    description: "Thought leader, innovates and drives best practices",
    color: "#22c55e"
  }
];

export const headerCards = [
  {
    title: "Take Assessment",
    description: "Complete your capability index assessment with detailed scoring across 6 dimensions.",
    icon: "📋",
    iconColor: "#3b82f6",
  },
  {
    title: "Manage Assessments",
    description: "View, edit, and delete assessment records (Admin & Manager access only).",
    icon: "⚙️",
    iconColor: "#a855f7",
  },
  {
    title: "Dashboard",
    description: "View comprehensive analytics and insights on team capabilities and performance.",
    icon: "📊",
    iconColor: "#fb923c",
  },
  {
    title: "Calibration Review",
    description: "Compare self vs manager assessments and identify discrepancies for review.",
    icon: "🎯",
    iconColor: "#ec4899",
  },
  {
    title: "Advanced Insights",
    description: "Deep dive into geographic trends, experience correlation, and team dynamics.",
    icon: "📈"
  },
  {
  title: 'Assessment Cycles',
  icon: "⚙️",
  description: 'Manage assessment cycles, timelines, and publishing.',
  iconColor: '#d4f4dd',
},
];
